module.exports = __webpack_public_path__ + "static/media/MicroAnimated.e6020631.gif";